'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { useGenerateBudgetRange } from '@/store/generate';

export type BudgetRange = {
  id: 'budget-low' | 'budget-medium' | 'budget-high';
  value: string;
  label: string;
  emoji: string;
};

export const budgetOptions: BudgetRange[] = [
  { id: 'budget-low', value: '$', label: 'Modest', emoji: '💰' },
  { id: 'budget-medium', value: '$$', label: 'Standard', emoji: '💰💰' },
  { id: 'budget-high', value: '$$$', label: 'Premium', emoji: '💰💰💰' },
];

export const getBudgetRangeDisplay = (id: string): string => {
  const option = budgetOptions.find(opt => opt.id === id);
  return option ? `${option.emoji} ${option.label}` : id;
};

export function BudgetRangeSelect() {
  const { budgetRange, setBudgetRange } = useGenerateBudgetRange();

  return (
    <div>
      <Label htmlFor="budget" className="mb-1.5 block text-sm font-semibold text-gray-700">
        Budget range
      </Label>
      <Select name="budget" value={budgetRange} onValueChange={setBudgetRange}>
        <SelectTrigger id="budget" className="w-full">
          <SelectValue placeholder="Select budget" />
        </SelectTrigger>
        <SelectContent>
          {budgetOptions.map(budget => (
            <SelectItem key={budget.id} value={budget.id}>
              {budget.emoji} {budget.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
